import { render } from "./UserVoteSelected.vue?vue&type=template&id=2c31f081&scoped=true"
import script from "./UserVoteSelected.vue?vue&type=script&lang=js"
export * from "./UserVoteSelected.vue?vue&type=script&lang=js"

import "./UserVoteSelected.vue?vue&type=style&index=0&id=2c31f081&lang=scss&scoped=true"

import exportComponent from "/Users/johnahnz0rs/00 - JAHN PROJECTS/movie-night/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c31f081"]])

export default __exports__